import { render, staticRenderFns } from "./accountEditModal.vue?vue&type=template&id=5b3e4572&scoped=true&"
import script from "./accountEditModal.vue?vue&type=script&lang=js&"
export * from "./accountEditModal.vue?vue&type=script&lang=js&"
import style0 from "./accountEditModal.vue?vue&type=style&index=0&id=5b3e4572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e4572",
  null
  
)

export default component.exports